import * as angular from 'angular';

import { ApplicationUserViewModel, ComponentDefinition, ITrackableViewModel, TrackableObjectBase } from '../../models';
import { getTrackable } from './getTrackable';

class ContextualMenuController implements angular.IComponentController, angular.IOnChanges {
    titleText: string; // I think it can be readonly as well
    trackable: ITrackableViewModel;

    readonly item: any;
    readonly users: ApplicationUserViewModel[];

    static $inject = ['$translate'];
    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    $onChanges(_onChangesObj: angular.IOnChangesObject): void {
        if (!this.trackable) {
            this.trackable = {} as ITrackableViewModel;
        }
        if (this.item && this.users && this.users.length > 0) {
            this.setTrackable(this.users, this.item);
        }
    }

    private setTrackable(users: ApplicationUserViewModel[], item: TrackableObjectBase) {
        this.trackable = getTrackable(users, item, this._$translate.instant('Unknown creator'));
    }
}

export const wtContextualMenu: ComponentDefinition = {
    componentId: 'wtContextualMenu',
    controller: ContextualMenuController,
    controllerAs: 'vm',
    template: require('./contextualMenu.component.html'),
    transclude: true,
    bindings: {
        titleText: '@',
        item: '<',
        users: '<'
    }
};